/** ----------------------------------------
    Imports
 ---------------------------------------- */

// Temporary use local translations
import base from '@translate/base';
import quickscan from '@translate/quickscan';
import apply from '@translate/apply';

const data = {
    ...base,
    ...quickscan,
    ...apply,
};

/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        data: data, // Temporary use local translations
        timestamp: null,
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;